export default "__VITE_ASSET__DwoqFIYI__"